import React, { useState, useEffect, useContext } from 'react';
// import '../assets/style.css';
// import '../assets/css/index.css';
// import '../assets/css/grid.css';
// import '../assets/css/theme.css';

// import '../assets/boxicons-2.0.7/css/boxicons.min.css';
import FeedBackPopup from './practice/FeedBackPopup';

import useSound from 'use-sound';
import { Link } from 'react-router-dom';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import NewQuestionBox from './NewQuestionBox';
import ImagewithTextField from './ImagewithTextField';
import TexttoSpeechwithTextfield from './TexttoSpeechwithTextfield';
import QuestionswithTextField from './QuestionswithTextField';
import ImagewithRadio from './ImagewithRadio';
import MapwithRadio from './MapwithRadio';
import CorrectAnswers from './CorrectAnswers';
import Lottie from 'react-lottie';
import { default as animationData } from '../assets/loader.json';
import Amplify, { Auth } from 'aws-amplify';
import config from '../aws-exports';
import { UserContext } from './UserContext';
import { useLocation } from 'react-router';
import StatusCard from './status-card/StatusCard';
import statusCards from '../assets/status-card-data.json';

import { withAuthenticator } from 'aws-amplify-react';
import Timer from './Timer';

import { default as animationData1 } from '../assets/congratulations.json';
import { default as animationData2 } from '../assets/tryagain.json';

import { cx } from '@emotion/css';
import { button } from '../styles/components/buttons.style';
import * as styles from './quizApp.style';
import Confetti from 'react-confetti';

Amplify.configure(config);

function QuizApp(props) {
  const [questionBank, set_questionBank] = useState([]);
  const [score, set_score] = useState(0);
  const [username, set_username] = useState('');
  const [useremail, set_useremail] = useState('');

  const incrementScore = () => set_score(score + 1);
  const [noofquestionsattended, set_noquestionsattended] = useState(0);
  const [questionnumber, set_questionnumber] = useState(1);
  const [useranswer, set_useranswer] = useState('');
  const [totalquestions, set_totalquestions] = useState(0);
  const [finished, is_finished] = useState(false);
  const [imagewithtextfield, is_imagewithtextfield] = useState(false);
  const [imagewithradio, is_imagewithradio] = useState(false);
  const [questionwithradio, is_questionwithradio] = useState(false);
  const [questionwithtextfield, is_questionwithtextfield] = useState(false);
  const [texttospeechwithtextfield, is_texttospeechwithtextfield] =
    useState(false);
  const [drawquestions, is_drawquestions] = useState(false);
  //const [user_answers, set_user_answers] = useState([]);
  const [user_answers_right, set_user_answers_right] = useState({});
  const [user_answers_right1, set_user_answers_right1] = useState({});
  const [event_activity_answers, set_event_activity_answers] = useState({});
  const [real_answers, set_real_answers] = useState({});
  const [jwt_token, set_jwt_token] = useState({});

  const [isfbackOpen, setIsfbackOpen] = useState(false);
  const [case_checker, set_case_checker] = useState({});
  var [fdback_id, set_fdback_id] = useState(0);
  const [presentquestion, set_presentquestion] = useState({
    answers: (4)[('Italy', 'Russia', 'USA', 'Germany')],
    attempts: 0,
    category: 'Sports',
    correctanswer: 'Russia',
    failures: 0,
    id: 0,
    level: 3,
    question: 'Which country hosted 2014 Winter Olympics?',
    specificcategory: 'Olympics',
    subcategory: 'Sports',
  });

  const [playActive] = useSound('../assets/pop.mp3', { volume: 0.25 });

  const [playNext] = useSound('../assets/nextorback.mp3', { volume: 0.25 });

  const [playClock] = useSound('../assets/clock.mp3', { volume: 0.75 });

  const [playPass] = useSound('../assets/pass.mp3', { volume: 0.75 });

  const [playFail] = useSound('../assets/fail.mp3', { volume: 0.75 });

  const { user, setUser } = useContext(UserContext);
  // const {user,setUser} = useContext(UserContext);
  let data1 = useLocation();
  // ////console.log("Calling EventsScreen.....")
  // ////console.log(data1.state)
  // const specificcategory = data1.state["specificcategory"]
  // const level1 = data1.state["level"]
  // const limits = data1["limits"]
  // const eventdisplay = data1["eventdisplay"]
  // ////console.log(specificcategory)
  // ////console.log(level1)
  // ////console.log(limits)
  // ////console.log(eventdisplay)
  let answ = [];

  function playAgainplease() {
    set_score(0);
    set_questionnumber(1);
    set_noquestionsattended(0);
    is_finished(false);
    set_user_answers_right({});
    set_user_answers_right1({});
    set_event_activity_answers({});
    getToken();
    set_real_answers({});
  }

  const getToken = async (id, level, category) => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();


      Auth.currentSession().then((res) => {
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();
        set_useremail(user.attributes['email'])

        set_presentquestion({
          answers: (4)[('Italy', 'Russia', 'USA', 'Germany')],
          attempts: 0,
          category: 'Sports',
          correctanswer: 'Russia',
          failures: 0,
          id: 0,
          level: 3,
          question: 'Which country hosted 2014 Winter Olympics?',
          specificcategory: 'Olympics',
          subcategory: 'Sports',
        });
        if (user.username.includes("Google_")) {


          set_username(user.attributes['email'])

          getQuestionfromDB(jwt);
          updateEventyActivity(user.attributes['email'], user.attributes['email'], jwt, 0, 'initiated');
          set_jwt_token(jwt);




        }
        else {
          getQuestionfromDB(jwt);
          set_jwt_token(jwt);
          set_username(user.username)
          updateEventyActivity(user.username, user.attributes['email'], jwt, 0, 'initiated');




        }







      });




    } catch (error) {
      // console.log(error)
      Auth.signOut()
    }
  };


  // const getToken = async (id, level, category) => {
  //   Auth.currentSession().then((res) => {
  //     ////console.log(Auth.user.attributes.email)
  //     let accessToken = res.getAccessToken();
  //     let jwt = accessToken.getJwtToken();
  //     set_presentquestion({
  //       answers: (4)[('Italy', 'Russia', 'USA', 'Germany')],
  //       attempts: 0,
  //       category: 'Sports',
  //       correctanswer: 'Russia',
  //       failures: 0,
  //       id: 0,
  //       level: 3,
  //       question: 'Which country hosted 2014 Winter Olympics?',
  //       specificcategory: 'Olympics',
  //       subcategory: 'Sports',
  //     });
  //     getQuestionfromDB(jwt);
  //     updateEventyActivity(jwt, 0, 'initiated');
  //     set_jwt_token(jwt);
  //   });
  // };


  function togglePopupwithId(id) {

    setIsfbackOpen(!isfbackOpen);
    set_fdback_id(id)

  }



  function closeFeedBackNew() {
    ////console.log("REached parent screen")

    setIsfbackOpen(!isfbackOpen)

  }



  const updateEventyActivity = async (user, email, jwt, updatedscore, operation) => {
    var questionno;
    let eventanswermap = {};
    var json;


    // console.log("calling updateEventyActivity")
    // console.log(updatedscore)
    for (questionno in questionBank) {
      ////console.log(questionno)
      ////console.log(questionBank[questionno].question)
      var question;
      if (imagewithtextfield) {
        question =
          '<img src = ' +
          questionBank[questionno].question +
          ' height: 100px, width: 100px />';
      } else {
        question = questionBank[questionno].question;
      }
      answ[questionno] =
        'Q: ' +
        questionno +
        ' Question: ' +
        question +
        ' Correct Answer: ' +
        questionBank[questionno].correctanswer +
        ' Your selection: ' +
        user_answers_right[questionBank[questionno]?.id];

      json = JSON.stringify({
        correctanswer: questionBank[questionno].correctanswer,
        question: questionBank[questionno].question,
        useranswer: user_answers_right[questionBank[questionno]?.id] || ''
      });

      eventanswermap[questionno] = json;
    }

    set_event_activity_answers(eventanswermap);

    ////console.log(answ)

    ////console.log("Before updating event activity")
    ////console.log(eventanswermap)

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      // body: JSON.stringify({'question': id , 'tablename': category+"Questions",'level': level})
      body: JSON.stringify({
        eventid: data1?.state['id'],
        eventname: data1?.state['name'],
        username: user,
        score: updatedscore,
        timetaken: 10,
        targetscore: data1.state['qualificationno'],
        level: data1.state['level'],
        operation: operation,
        description: data1.state['name'],
        emailid: email,
        category: data1.state['category'],
        correctanswers: answ,
        emailtobesend: data1.state['sendEmail']
          ? data1.state['sendEmail']
          : false,
        eventemailid: data1.state['email']
          ? data1.state['email']
          : email,
        useranswers: eventanswermap,
      }),
    };
    // console.log("Response Option is : ",requestOptions);
    const response = await fetch(
      `https://api.quizwizard.net/quiz/eventactivity`,
      requestOptions
    );
    // console.log("Response is : ",response);
    const data = await response.json();
    // console.log("After Event Activity")
    // console.log(data)
  };

  const updateUserScore = async (jwt, updatedscore) => {
    let newscore = 0;
    const userCopy = { ...user };
    if (updatedscore >= data1.state['qualificationno']) {
      newscore = userCopy['score'] + data1.state['points'];
      userCopy['score'] = newscore;
    } else {
      newscore = userCopy['score'] - data1.state['points'];
      userCopy['score'] = newscore;
    }

    const updateScoreOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({
        username: user['username'],
        score: newscore,
        appname: 'QuizWhiz',
        id: user['username'],
      }),
    };

    const response = await fetch(
      `https://api.quizwizard.net/quiz/updatescore`,
      updateScoreOptions
    );
    const data = await response.json();
    ////console.log("After calling Update Score")
    setUser(userCopy);
  };

  const getQuestionfromDB = async (jwt) => {
    const specificcategory = data1.state['specificcategory'];
    const level1 = data1.state['levels'];
    const limits = data1.state['limits'];
    const eventdisplay = data1.state['eventdisplay'];

    is_imagewithtextfield(false);
    is_imagewithradio(false);
    is_texttospeechwithtextfield(false);
    is_drawquestions(false);
    is_questionwithradio(false);
    is_questionwithtextfield(false);

    //  ////console.log("is_imagewithtextfield")
    //  ////console.log(is_imagewithtextfield)
    //  ////console.log("is_imagewithradio")
    //  ////console.log(is_imagewithradio)
    //  ////console.log("is_questionwithradio")
    //  ////console.log(is_questionwithradio)

    var specificcategoryreplace = ('' + specificcategory).replace(/%20/g, ' ');

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      // body: JSON.stringify({'question': id , 'tablename': category+"Questions",'level': level})
      body: JSON.stringify({
        category: 'Mathematics',
        level: level1,
        levels: ('' + level1).split(',').map(Number),
        limits: ('' + limits).split(',').map(Number),
        name: 'Math1',
        noofretries: 1,
        points: 5,
        qualificationno: 9,
        subcategory: ['Addition'],
        specificcategory: ('' + specificcategoryreplace).split(','),
        time: 60,
        totalquestions: 10,
      }),
    };


    const response = await fetch(
      `https://api.quizwizard.net/quiz/getquestions`,
      requestOptions
    );
    const data = await response.json();

    set_questionBank(data);
    // console.log("Here data is : ", data);

    // Check if there's at least one question
    if (data.length > 0) {
        set_presentquestion(data[0]);
    } else {
        console.warn("No questions received from the server.");
        set_presentquestion(null); // or show a message in UI
        return;
    }


    //////console.log(presentquestion)
    //////console.log(data)

    var questionno;
    let dict_answer = real_answers;
    let case_checkercondition = [];
    for (questionno in data) {
      dict_answer[data[questionno]?.id] = data[questionno]?.correctanswer;
      case_checkercondition[data[questionno]?.id] = data[questionno]?.ignorecases;
    }
    set_real_answers(dict_answer);
    set_case_checker(case_checkercondition);
    ////console.log("Real Answers are ")
    //console.log(set_case_checker)
    var displayformat = data[0]['displayformat'] || (data1 && data1.state && data1.state['eventdisplay']);
    //console.log(displayformat)

    const formatStr = typeof displayformat === 'string' ? displayformat.toLowerCase().trim() : "";

    if (formatStr === 'imagewithtextfield') {
      is_imagewithtextfield(true);
    } else if (formatStr === 'imagewithradio') {
      is_imagewithradio(true);
    } else if (formatStr === 'speaktextwithtextfield') {
      is_texttospeechwithtextfield(true);
      ////console.log("seetingis_texttospeechwithtextfield(true) ")
    } else if (formatStr === 'questionswithtextfield' || formatStr === 'textwithtextfield') {
      is_questionwithtextfield(true);
    } else if (formatStr === 'drawquestions') {
      is_drawquestions(true);
    } else {
      is_questionwithradio(true);
    }
  };

  function computeAnswer(answer, id) {
    playActive();
    //playClock()
    let useranswermap = user_answers_right;
    useranswermap[id] = answer;

    set_user_answers_right(useranswermap);
    //////console.log(user_answers_right)
  }

  const selectedanswers = () => {
    // if(answer == real_answers[id])
    // {
    //   set_score(score + 1)
    // }

    //0 console.log(noofquestionsattended)
    //console.log(totalquestions)

    //noofquestionsattended = noofquestionsattended + 1

    playNext();
    if (noofquestionsattended + 1 < totalquestions) {
      set_questionnumber(questionnumber + 1);
      set_presentquestion(questionBank[noofquestionsattended + 1]);

      var displayformat =
        questionBank[noofquestionsattended + 1]['displayformat'] || (data1 && data1.state && data1.state['eventdisplay']);
      is_imagewithtextfield(false);
      is_imagewithradio(false);
      is_texttospeechwithtextfield(false);
      is_drawquestions(false);
      is_questionwithradio(false);
      is_questionwithtextfield(false);
      
      const formatStr = typeof displayformat === 'string' ? displayformat.toLowerCase().trim() : "";

      if (formatStr === 'imagewithtextfield') {
        is_imagewithtextfield(true);
      } else if (formatStr === 'imagewithradio') {
        is_imagewithradio(true);
      } else if (formatStr === 'speaktextwithtextfield') {
        is_texttospeechwithtextfield(true);
        ////console.log("seetingis_texttospeechwithtextfield(true) ")
      } else if (formatStr === 'questionswithtextfield' || formatStr === 'textwithtextfield') {
        is_questionwithtextfield(true);
      } else if (formatStr === 'drawquestions') {
        is_drawquestions(true);
      } else {
        is_questionwithradio(true);
      }

      set_noquestionsattended(noofquestionsattended + 1);
      set_user_answers_right1(user_answers_right);
      //////console.log(noofquestionsattended)
    } else {
      //Lets update

      ////console.log("What user selected is ")
      ////console.log(user_answers_right)
      ////console.log("What real answer is  ")
      ////console.log(real_answers)
      let actualScore = 0;
      var key, val;
      // for ([key, val] of Object.entries(user_answers_right)) {
      //   ////console.log(key, val);
      //   if (case_checker[key] == "true") {

      //     if (real_answers[key].trim().toLowerCase() == val.trim().toLowerCase()) {
      //       ////console.log("Correct Answer");
      //       actualScore = actualScore + 1;
      //       ////console.log(actualScore)


      //       //set_score(10)
      //     }

      //   }

      //   else {
      //     ////console.log(real_answers[key])
      //     if (real_answers[key].trim() == val.trim()) {
      //       ////console.log("Correct Answer");
      //       actualScore = actualScore + 1;
      //       ////console.log(actualScore)


      //       //set_score(10)
      //     }
      //   }
      // }
      for ([key, val] of Object.entries(user_answers_right)) {
        const realAnswer = real_answers[key];
        const userAnswer = val;

        if (typeof realAnswer === 'string' && typeof userAnswer === 'string') {
          let normalizedReal = realAnswer.replace(/\$/g, '').trim();
          let normalizedUser = userAnswer.replace(/\$/g, '').trim();

          if (data1.state && data1.state['category'] === 'Mathematics') {
            normalizedReal = normalizedReal.replace(/\s+/g, '');
            normalizedUser = normalizedUser.replace(/\s+/g, '');
          }

          if (case_checker[key] === "true") {
            if (normalizedReal.toLowerCase() === normalizedUser.toLowerCase()) {
              actualScore += 1;
            }
          } else {
            if (normalizedReal === normalizedUser) {
              actualScore += 1;
            }
          }
        } else {
          console.warn(`Invalid answer type for key ${key}: real=${realAnswer}, user=${userAnswer}`);
        }
      }


      set_score(actualScore);
      is_finished(true);
      if (
        actualScore >= data1.state['qualificationno'] &&
        data1.state['eventtype'] != 'Assignments'
      ) {
        playPass();
      } else if (data1.state['eventtype'] != 'Assignments') {
        playFail();
      }
      ////console.log("finsihed")
      ////console.log(finished)
      updateUserScore(jwt_token, actualScore);
      updateEventyActivity(username, useremail, jwt_token, actualScore, 'ended');
      // setUser(user);
      // console.log('parent', user);
    }

    // if(noofquestionsattended + 1  > totalquestions )
    // {
    //   is_finished(true)
    // }

    // set_presentquestion(questionBank[noofquestionsattended])
    //is_finished(true)
  };

  function backanswers() {
    // if(answer == real_answers[id])
    // {
    //   set_score(score + 1)
    // }
    playNext();
    ////////console.log(user_answers)
    //noofquestionsattended = noofquestionsattended + 1
    if (noofquestionsattended > 0) {
      set_questionnumber(questionnumber - 1);
      set_presentquestion(questionBank[noofquestionsattended - 1]);
      set_noquestionsattended(noofquestionsattended - 1);

      is_imagewithtextfield(false);
      is_imagewithradio(false);
      is_texttospeechwithtextfield(false);
      is_drawquestions(false);
      is_questionwithradio(false);
      is_questionwithtextfield(false);

      var displayformat =
        questionBank[noofquestionsattended - 1]['displayformat'] || (data1 && data1.state && data1.state['eventdisplay']);

      const formatStr = typeof displayformat === 'string' ? displayformat.toLowerCase().trim() : "";

      if (formatStr === 'imagewithtextfield') {
        is_imagewithtextfield(true);
      } else if (formatStr === 'imagewithradio') {
        is_imagewithradio(true);
      } else if (formatStr === 'speaktextwithtextfield') {
        is_texttospeechwithtextfield(true);
        ////console.log("seetingis_texttospeechwithtextfield(true) ")
      } else if (formatStr === 'questionswithtextfield' || formatStr === 'textwithtextfield') {
        is_questionwithtextfield(true);
      } else if (formatStr === 'drawquestions') {
        is_drawquestions(true);
      } else {
        is_questionwithradio(true);
      }

      //////console.log(noofquestionsattended)
    } else {
      //Lets update
      // is_finished(true)
      // updateEventyActivity(jwt_token)
    }
    // if(noofquestionsattended + 1  > totalquestions )
    // {
    //   is_finished(true)
    // }

    // set_presentquestion(questionBank[noofquestionsattended])
    //is_finished(true)
  }

  function handleCallback(childData) {
    let actualScore = 0;
    var key, val;
    for ([key, val] of Object.entries(user_answers_right)) {
      if (real_answers[key] == val || real_answers[key] == 'Spell ' + val) {
        actualScore = actualScore + 1;
        set_score(actualScore);
      }
    }

    is_finished(true);
    updateUserScore(jwt_token, actualScore);
    updateEventyActivity(username, useremail, jwt_token, actualScore, 'ended');
  }



  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const congratsOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const tryagainOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    let isMounted = true;
    ////console.log("UseEffect calling in QuizApp")
    getToken();
    document.title = 'Quiz';
    // updateEventyActivity(jwt_token, 0);

    const totalquestions = data1.state['totalquestions'];
    set_totalquestions(totalquestions);
    // console.log("Playing clock")
    playClock();
    return () => {
      isMounted = false;
    };
  }, []);

  const controlButtons = (
    <>
      {presentquestion &&  presentquestion?.id > 0 && finished == false ? (
        <div
          className={
            (questionwithtextfield ||
              texttospeechwithtextfield ||
              imagewithtextfield) &&
            cx(styles.buttonGroup)
          }
        >
          <button key="Back" onClick={backanswers}>
            Back
          </button>
          <button key="Next" onClick={selectedanswers}>
            Next
          </button>
        </div>
      ) : null}
    </>
  );

  return (
    <div>
      {finished &&
        score >= data1.state['qualificationno'] &&
        data1.state['eventtype'] != 'Assignments' && (
          <div className={styles.overflowXHidden}>
            <Confetti />
          </div>
        )}
      <div>
        <div
          className={`${finished ? 'no-shadow inner ' : ''}${cx(
            styles.container
          )}`}
        >
          {/* 
      Show only for Events */}
          {finished &&
            score < data1.state['qualificationno'] &&
            data1.state['eventtype'] != 'Assignments' ? (
            <div>
              <img
                className={cx(styles.img)}
                src={require('../assets/images/icon-sad.jpeg').default}
                alt=""
              />
              <div className={`${cx(styles.title)} text-center`}>
                Score {score}/{data1.state['totalquestions']}
              </div>
              <img
                className={cx(styles.img)}
                src={require('../assets/images/oops.jpeg').default}
                alt=""
              />
              <p className={`text-center color-black ${styles.title}`}>
                Try Again
              </p>
              <p className={`text-center ${styles.line}`}>
                <span>{data1.state['points']}</span> points deduced from your
                account
              </p>
              <div className={cx(styles.attempt)}>
                You have{' '}
                <span>
                  {data1.state['remainingattempts'] > 0
                    ? data1.state['remainingattempts']
                    : 'no'}
                </span>{' '}
                remaining attempts
              </div>
            </div>
          ) : (
            ''
          )}

          {/* 
      Show only for Events */}
          {finished &&
            score >= data1.state['qualificationno'] &&
            data1.state['eventtype'] != 'Assignments' ? (
            <div>
              <img
                className={cx(styles.img)}
                src={require('../assets/images/happy.jpeg').default}
                alt=""
              />
              <div className={`${cx(styles.title)} text-center`}>
                Score {score}/{data1.state['totalquestions']}
              </div>
              <img
                className={cx(styles.img)}
                src={require('../assets/images/congo.jpeg').default}
                alt=""
              />
              <p className={`text-center color-black ${styles.title}`}>
                You cleared the event
              </p>
              <p className={`text-center ${styles.line}`}>
                Your earned <span>{data1.state['points']}</span> points
              </p>
            </div>
          ) : (
            ''
          )}

          {/* Show only for Assignments */}
          {finished && data1.state['eventtype'] == 'Assignments' ? (
            <div style={{
              background: 'linear-gradient(135deg, #ffffff 0%, #fffdfa 100%)',
              border: '2px solid rgba(241, 102, 2, 0.15)',
              borderRadius: '24px',
              padding: '3rem 2rem',
              boxShadow: '0 20px 50px rgba(241, 102, 2, 0.08)',
              textAlign: 'center',
              marginBottom: '2rem',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <style>{`
                @keyframes popInSuccess {
                  0% { opacity: 0; transform: scale(0.5) rotate(-15deg); }
                  70% { transform: scale(1.1) rotate(5deg); }
                  100% { opacity: 1; transform: scale(1) rotate(0); }
                }
              `}</style>
              <div style={{
                position: 'absolute', top: '-50px', right: '-50px',
                width: '150px', height: '150px', background: 'radial-gradient(circle, rgba(241,102,2,0.1) 0%, transparent 70%)', borderRadius: '50%'
              }} />
              <div style={{
                position: 'absolute', bottom: '-50px', left: '-50px',
                width: '150px', height: '150px', background: 'radial-gradient(circle, rgba(244,203,14,0.15) 0%, transparent 70%)', borderRadius: '50%'
              }} />
              
              <div style={{
                width: '90px', height: '90px', margin: '0 auto 1.5rem',
                background: 'linear-gradient(135deg, #f16602 0%, #ff9a45 100%)',
                borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: '0 10px 25px rgba(241,102,2,0.3)',
                animation: 'popInSuccess 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards'
              }}>
                <svg width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
              </div>
              <h2 style={{ fontSize: '2.4rem', fontWeight: '800', color: '#382110', margin: '0 0 0.5rem', letterSpacing: '-0.02em', fontFamily: "'Outfit', 'Inter', sans-serif" }}>
                Mission <span style={{ color: '#f16602' }}>Accomplished!</span>
              </h2>
              <p style={{ fontSize: '1.05rem', color: '#6b574a', margin: '0', fontWeight: '500', fontFamily: "'Inter', sans-serif" }}>
                Your assignment has been successfully submitted and recorded.
              </p>
            </div>
          ) : (
            ''
          )}

          {/* 
      Show only for all questions */}
          {presentquestion?.id > 0 && finished == false ? (
            <div className={styles.progress}>
              {questionBank.length > 0 ? (
                <>
                  <CountdownCircleTimer
                    isPlaying
                    duration={data1.state['time'] * data1.state['totalquestions']}
                    colors={['#eed017']}
                    size={105}
                    strokeWidth={7}
                    onComplete={handleCallback}
                  >
                    {({ remainingTime }) => {
                      const minutes = Math.floor(remainingTime / 60);
                      const seconds = remainingTime % 60;

                      return (
                        <div
                          className="text-center"
                          style={{ fontSize: '17px' }}
                        >
                          {minutes}:{seconds}
                          <br />
                          MIN
                        </div>
                      );
                    }}
                  </CountdownCircleTimer>
                  <p className="s-title">time remaining </p>
                </>
              ) : (
                ''
              )}{' '}
            </div>
          ) : (
            ' '
          )}

{presentquestion && presentquestion?.id > 0 && !finished && imagewithradio ? (
    <ImagewithRadio
        question={presentquestion.question}
        answer={presentquestion.answers}
        imageurl={presentquestion.imageurl}
        id={presentquestion?.id}
        key={presentquestion?.id}
        selected={(answer) => computeAnswer(answer, presentquestion?.id)}
        selectedanswer={user_answers_right[presentquestion?.id]}
        subcategory={presentquestion?.subcategory}
        questionnumber={questionnumber}
        questionCount={questionBank.length}
    />
) : presentquestion === null ? (
    <div style={{ textAlign: "center", marginTop: "2rem" }}>
        <h2>No questions found for this event.</h2>
        <p>Please check back later or try another category.</p>
    </div>
) : null}

{presentquestion && presentquestion?.id > 0 && !finished && imagewithtextfield ? (
    <ImagewithTextField
        question={presentquestion.question}
        answer={presentquestion.answers}
        id={presentquestion.id}
        imageurl={presentquestion.imageurl}
        key={presentquestion.id}
        selected={(answer) => computeAnswer(answer, presentquestion.id)}
        selectedanswer={user_answers_right[presentquestion.id]}
        subcategory={presentquestion.subcategory}
        questionnumber={questionnumber}
        questionCount={questionBank.length}
        specific_category={presentquestion.specificcategory}
    />
) : null}


          {finished && (
            <div>
              <div className={cx(styles.summary)}>
                <div className="item">
                  <p className="s-title">{totalquestions}</p>
                  <p className="sub-title">Question</p>
                </div>
                <div className="item">
                  <p style={{ color: '#2ec32b' }} className="s-title">
                    {score}
                  </p>
                  <p className="sub-title">Correct Answer</p>
                </div>
                <div className="item">
                  <p style={{ color: '#c32b2b' }} className="s-title">
                    {totalquestions - score}
                  </p>
                  <p className="sub-title">Wrong Answer</p>
                </div>
                <div className="item">
                  <p style={{ color: '#dd7029' }} className="s-title">
                    {Math.floor((score / totalquestions) * 100)}%
                  </p>
                  <p className="sub-title">Result</p>
                </div>
              </div>
            </div>
          )}

          {presentquestion?.id > 0 &&
            finished == false &&
            texttospeechwithtextfield ? (
            <TexttoSpeechwithTextfield
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              nextbutton={selectedanswers}
              questionCount={questionBank.length}
              specific_category={presentquestion.specificcategory}
              meaning={presentquestion.meaning}
              category={presentquestion.category}
              audio={presentquestion.audio}
              example={presentquestion.example}
              word_to_pronounce={presentquestion.correctanswer}

            />
          ) : null}

          {presentquestion?.id > 0 &&
            finished == false &&
            questionwithtextfield ? (
            <QuestionswithTextField
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              key={presentquestion.id}
              note={presentquestion.extranote}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer={user_answers_right[presentquestion.id]}
              subcategory={presentquestion.subcategory}
              questionnumber={questionnumber}
              nextbutton={selectedanswers}
              questionCount={questionBank.length}
            />
          ) : null}

          {presentquestion?.id > 0 && finished == false && questionwithradio ? (
            <NewQuestionBox
              question={presentquestion.question}
              answer={presentquestion.answers}
              id={presentquestion.id}
              questionnumber={questionnumber}
              key={presentquestion.id}
              selected={(answer) => computeAnswer(answer, presentquestion.id)}
              selectedanswer1={user_answers_right1[presentquestion.id]}
              category={data1.state['subcategory']}
              questionCount={questionBank.length}
              controlButtons={controlButtons}
            />
          ) : null}

          {!questionwithradio && controlButtons}

          {presentquestion?.id <= 0 ? (
            <div className="welcomecenter">
              <Lottie options={defaultOptions} height={400} width={400} />
            </div>
          ) : (
            ''
          )}

          <div className="table-responsive">
            {finished && data1.state['eventtype'] != 'Event' && (
              <div style={{
                background: '#ffffff',
                borderRadius: '20px',
                border: '1px solid rgba(241, 102, 2, 0.15)',
                boxShadow: '0 10px 30px rgba(0,0,0,0.03)',
                padding: '2rem',
                marginBottom: '30px',
                overflow: 'hidden'
              }}>
                <h3 style={{
                  fontSize: '1.4rem', fontWeight: '800', color: '#382110',
                  marginBottom: '1.5rem', textAlign: 'center', textTransform: 'uppercase', letterSpacing: '0.05em'
                }}>
                  Performance <span style={{ color: '#f16602' }}>Review</span>
                </h3>
                <table
                  border={0}
                  cellPadding={0}
                  cellSpacing={0}
                  className={cx(styles.table)}
                  style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 0 }}
                >
                  <thead>
                    <tr>
                      <th style={{ padding: '15px', background: 'rgba(241,102,2,0.06)', color: '#f16602', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', borderRadius: '12px 0 0 12px' }}>Question</th>
                      <th style={{ padding: '15px', background: 'rgba(241,102,2,0.06)', color: '#f16602', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Correct Answer</th>
                      <th style={{ padding: '15px', background: 'rgba(241,102,2,0.06)', color: '#f16602', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Your Answer</th>
                      <th style={{ padding: '15px', background: 'rgba(241,102,2,0.06)', color: '#f16602', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Result</th>
                      <th style={{ padding: '15px', background: 'rgba(241,102,2,0.06)', color: '#f16602', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em', borderRadius: '0 12px 12px 0' }}>Feedback</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data1.state['eventtype'] == 'Assignments' && questionBank.map(
                      ({
                        question,
                        correctanswer,
                        id,
                        ignorecases,
                      }, index) => (
                        <CorrectAnswers
                          question={question}
                          correctanswer={correctanswer !== undefined ? correctanswer : ""}
                          id={id}
                          key={id}
                          alternateanswers={[]}
                          selectedanswer={user_answers_right[id] !== undefined ? user_answers_right[id] : ""}
                          eventtype={data1.state['eventdisplay']}
                          ignorecases={ignorecases}
                          selected={(index) => togglePopupwithId(index)}
                          questionid={index}
                        />
                      )
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className={styles.btnGroup}>
            {finished &&
              score < data1.state['qualificationno'] &&
              data1.state['remainingattempts'] > 0 &&
              (questionwithradio || texttospeechwithtextfield) ? (
              <div className="text-center">
                <Link
                  to={{
                    pathname: '/events',
                    state: { category: data1.state['category'] },
                  }}
                >
                  <button className={cx(button)}> Play Again </button>
                </Link>
              </div>
            ) : (
              ''
            )}

            {finished && data1.state['eventtype'] != 'Assignments' ? (
              <div className="text-center">
                <Link
                  to={{
                    pathname: '/openevents',
                    state: data1.state['category'],
                  }}
                >
                  <button className={cx(button)}> Next Event </button>
                </Link>
              </div>
            ) : (
              ''
            )}

            {isfbackOpen && (
              <FeedBackPopup
                handleClose={closeFeedBackNew}
                selected={() => closeFeedBackNew()}
                eventname={data1.state['name']}
                presentquestion={questionBank[fdback_id]}
              />
            )}


            {finished && data1.state['eventtype'] == 'Assignments' ? (
              <div className="text-center">
                <Link
                  to={{
                    pathname: '/assignments',
                    state: data1.state['category'],
                  }}
                >
                  <button className={cx(button)}> Next Event </button>
                </Link>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default QuizApp;
